import { render } from "./ResultItemsContainer.vue?vue&type=template&id=34ca54fe&ts=true"
import script from "./ResultItemsContainer.vue?vue&type=script&lang=ts"
export * from "./ResultItemsContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__